import { apiSlice } from '../../api/apiSlice';

export const acAPI = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateSelfGenTimeOnTask: builder.mutation({
      query: (options) => ({
        url: `AccessControl/class/${options.classId}/SelfGenTimeOnTask`,
        method: 'PUT',
        body: options
      })
    }),
    updateAccessType: builder.mutation({
      query: (options) => ({
        url: `AccessControl/class/${options.classId}/AccessType`,
        method: 'PUT',
        body: options
      })
    })
  })
});

export const {
  useUpdateSelfGenTimeOnTaskMutation,
  useUpdateAccessTypeMutation
} = acAPI;